<template>
	<el-dialog :visible.sync="dialogVisible" title="附件列表" :close-on-click-modal="false" :append-to-body="true" width="1200px">
		<div class="down-container">
			<div class="down-box" v-for="(v, i) in downList" :key="i">
				<div>{{ v.fileName }}</div>
				<div class="down-link" @click="handleDown(v, i)">{{ v.annexDownUri }}</div>
				<el-button type="primary" size="mini" @click="handleDown(v, i)">下载</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: ['downList'],
	data() {
		return {
			dialogVisible: false,
		}
	},
	methods: {
		handleDown(v) {
			console.log(v)
			this.$emit('handleDown', v)
		},
	},
}
</script>

<style scoped>
.down-container {
	max-height: 500px;
	overflow-y: auto;
	box-sizing: border-box;
}
.down-box {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	width: 100%;
	padding: 0 50px 30px 50px;
}
.down-link {
	padding: 0 20px;
}
.down-link:hover {
	cursor: pointer;
	color: #2962b0;
}
</style>